module.exports = __webpack_public_path__ + "img/9791159312311.065dca5b.jpg";